import { render, staticRenderFns } from "./ControlMarca.vue?vue&type=template&id=91b0906c&"
import script from "./ControlMarca.vue?vue&type=script&lang=js&"
export * from "./ControlMarca.vue?vue&type=script&lang=js&"
import style0 from "./ControlMarca.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports